import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { logoutUser } from '../Auth/utilities/authUtils';
import { useNavigate, Link } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../config/firebaseConfig';
import SideMenu from '../Common/Menus/SideMenu';
import AppLogo from '../Common/Brand/AppLogo';

const Navbar = ({ currentURL, setError, navList, isAdmin }) => {

    const [showMenu, setShowMenu] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setIsAuthenticated(user !== null);
        });

        return unsubscribe;
    }, []);

    const visibleNavList = navList?.map(listGroup => ({ 
        ...listGroup,
        items: listGroup.items.filter(item => {
            const authPass = !item.auth || isAuthenticated;
            const adminPass = !item.admin || (isAuthenticated && isAdmin);
            return authPass && adminPass;
        })
    }));

    /**
     * Handle user logout
     */
    const handleLogout = async () => {
        try {
            await logoutUser();
            localStorage.removeItem('user');
            navigate('/login');
        } catch (err) {
            setError('Logout failed: ' + err.message);
        }
    };

    return (
        <>
            <SideMenu
                side="left"
                title="Student Portfolio Builder"
                headerIcon={<AppLogo size={44} />}
                expanded={showMenu}
                setExpanded={setShowMenu}
            >
                <div className="h-100 d-flex flex-column">
                    {navList && navList.map((listGroup, listGroupIndex) => (
                        listGroup.items.length > 0 && (
                            <div
                                key={listGroupIndex}
                                className={`nav-links flex-grow-1 flex-column ${
                                    listGroup.align === "bottom" ? "justify-content-end" : listGroup.align === "center" ? "justify-content-center" : "justify-content-start"
                                }`}
                            >
                                {listGroup.items.map((item, itemIndex) => {
                                    const authPass = !item.auth || isAuthenticated;
                                    const adminPass = !item.admin || (isAuthenticated && isAdmin);

                                    if (authPass && adminPass) {
                                        return (
                                            <Link
                                                key={item.key || `${item.href}-${item.name}-${listGroupIndex}-${itemIndex}`}
                                                to={item.href}
                                                className="nav-link pb-2"
                                            >
                                                {item.icon && <i className={`bi ${item.icon}`}></i>}
                                                <span className='ps-2'>{item.name}</span>
                                            </Link>
                                        );
                                    }
                                    return null;
                                })}
                            </div>
                        )
                    ))}
                    <div className='nav-links'>
                        {isAuthenticated ? (
                            <button className="nav-link pb-2" onClick={handleLogout}>
                                <i className="bi bi-box-arrow-left"></i>
                                <span className='ps-2'>Logout</span>
                            </button>
                        ) : 
                            <Link to="/login" className="nav-link pb-2">
                                <i className="bi bi-box-arrow-in-right"></i>
                                <span className='ps-2'>Login</span>
                            </Link>
                        }
                    </div>



                </div>


            </SideMenu>

            <button
                className={`btn btn-sm nav-button ${!showMenu && "show"}`}
                onClick={() => setShowMenu(true)}
                aria-label="Open navigation"
            >
                <AppLogo size={44} />
            </button>


        </>
    );
};

Navbar.propTypes = {
    currentPage: PropTypes.string,
    isAdmin: PropTypes.bool,
    navList: PropTypes.arrayOf(PropTypes.shape({
        align: PropTypes.oneOf(["top", "center", "bottom"]).isRequired,
        items: PropTypes.arrayOf(PropTypes.shape({
            key: PropTypes.string,
            name: PropTypes.string.isRequired,
            icon: PropTypes.node,
            href: PropTypes.string.isRequired,
            auth: PropTypes.bool,
            admin: PropTypes.bool,
        })).isRequired,
    })).isRequired,
};

export default Navbar;
